import { AuthService } from './auth.service';
import { Injectable, ElementRef, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { SmBaseService } from './sm-base.service';
import { ResponseContentType } from '@angular/http';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class SettingsService extends SmBaseService implements OnDestroy {
	private _cache: { [key: number]: Observable<any> } = {};
	_subscription: Subscription;

	constructor(
		http: HttpService,
		private _authService: AuthService
	) {
		super(http, 'settings');

		this._subscription = this._authService.onTokenChanged.subscribe((token) => {
			this.clearCache();
		});
	}

	ngOnDestroy() {
		this._subscription.unsubscribe();
	}

	clearCache() {
		this._cache = {};
	}

	getSettings<TSettings>(type: AccountSettingsType, force?: boolean): Observable<TSettings> {
		if (this._cache[type] == null || force == true) {
			this._cache[type] = this._getAs<TSettings>(type)
				.pipe(publishReplay(1))
				.pipe(refCount());
		}

		return this._cache[type];
	}

	setSettings<TSettings>(type: AccountSettingsType, settings: TSettings) {
		this._cache[type] = null;
		return this._post(type, settings);
	}

	deleteSettings(type: AccountSettingsType) {
		this._cache[type] = null;
		return this._delete(type);
	}

	printPreview<TSettings>(type: AccountSettingsType, settings: TSettings, anchor: ElementRef) {
		this._post(type + '/printpreview', settings, { responseType: ResponseContentType.Blob }).subscribe(model => {
			let blob = model.blob();
			let fileURL = URL.createObjectURL(blob);

			if ('download' in anchor.nativeElement) {
				anchor.nativeElement.href = fileURL;
				anchor.nativeElement.click();
			}
			else {
				window.location.href = fileURL;
			}
		});
	}
}

export enum AccountSettingsType {
	AccountSettingSection = 0,

	NotificationSettings = 10,

	GlobalPrintSettings = 20,
	ListOfTransportSettings = 21,
	MailLabelsSettings = 22,
	PostArcSettings = 23,

	// TemplatesSettings = 30,
	TemplateListSettings = 31,

	TransactionListSettings = 40,
	TransactionDetailSettings = 41,
	TransactionSituationsSettings = 43,
	// DeliveryCostsRulesSettings = 44,
	// DeliveryPricelistSettings = 45,
	CustomSystemSectionsSettings = 46,
	TransactionStatusAlarmSettings = 47
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/settings.service.ts